<template>
  <div class="Relax">
    <div class="Monthly_top">
      <h2 style="color: #fff;font-size: 22px;height: 80px;line-height:80px;margin-left:20px;float: left;">月度统计</h2>
      <div @click="Togglefun(1)" :class="Togglenum==1?'Select':''" style="height: 80px;color: rgba(169, 192, 232, 1); cursor: pointer; line-height:80px;margin-left:20%;float: left;position: relative;">设备使用概览<div v-if="Togglenum==1" class="triangle-down"></div></div>
      <div @click="Togglefun(2)" :class="Togglenum==2?'Select':''" style="height: 80px;color: rgba(169, 192, 232, 1); cursor: pointer; line-height:80px;margin-left:50px;float: left;position: relative;">训练情况概览<div class="triangle-down" v-if="Togglenum==2"></div></div>
      <div class="yuefen" style="position: absolute;right:255px;top:20px;width: 170px;">
        <div style="float: left;width: 80px;height: 40px;background: rgba(75, 108, 166, 1);color: #fff;line-height:40px;text-align: center;">统计月份</div>
        <el-select style="float: left;width: 90px;" v-model="region" placeholder="月份" @change='yuefenfun'>
          <el-option label="一月" value="01"></el-option>
          <el-option label="二月" value="02"></el-option>
          <el-option label="三月" value="03"></el-option>
          <el-option label="四月" value="04"></el-option>
          <el-option label="五月" value="05"></el-option>
          <el-option label="六月" value="06"></el-option>
          <el-option label="七月" value="07"></el-option>
          <el-option label="八月" value="08"></el-option>
          <el-option label="九月" value="09"></el-option>
          <el-option label="十月" value="10"></el-option>
          <el-option label="十一月" value="11"></el-option>
          <el-option label="十二月" value="12"></el-option>
        </el-select>
      </div>
      <el-button v-if="zhuti == 2" style="position: absolute;top:23px;right:120px" @click="qiehuanzhut(1)" type="primary" icon="el-icon-sunny">白昼主题</el-button>
      <el-button v-if="zhuti == 1" style="position: absolute;top:23px;right:120px" @click="qiehuanzhut(2)" type="primary" icon="el-icon-moon">暗色主题</el-button>
      <el-button style="position: absolute;top:23px;right:20px" type="primary" icon="el-icon-upload2">导出</el-button>
    </div>
    <div class="nav" :class="Togglenum==1?'nav1':'no'">
      <p style="color: var(--Monthly3);text-align: left;vertical-align: top;font-size: 18px;padding-top:20px;margin-left:20px">东南大学心理放松舱</p>
      <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);">截止{{datasgetFullYear}}年{{datasgetMonth}}月共 <span style="color: var(--Monthly3);">{{alldata.testPersonCount}}</span> 人采用放松舱进行身心调节，放松舱累计使用 <span style="color: var(--Monthly3);">{{alldata.testCount}}</span>人次，累计使用时长<span style="color: var(--Monthly3);">{{alldata.testTime}}</span>时</p>
      <ul class="nav-ul">
        <li>
          <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff; text-indent: 20px;text-align:center">使用人数</p>
          <p style="height: calc(100% - 40px);line-height:160px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata.testPersonCount}}人</p>
        </li>
        <li style="margin-left:-1px">
          <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff; text-indent: 20px;text-align:center">使用人次</p>
          <p style="height: calc(100% - 40px);line-height:160px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata.testCount}}次</p>
        </li>
        <li style="margin-left:-1px">
          <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff; text-indent: 20px;text-align:center">使用时长</p>
          <p style="height: calc(100% - 40px);line-height:160px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata.testTime}}H</p>
        </li>
      </ul>
      <div class="complete2" style="height: 450px;border:none">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px">设备使用情况统计</p>
        <ul class="sjli">
          <li>数据来源</li>
          <li style="cursor: pointer;" v-for="(item,i) in GetDictionaryList" :key="i" @click="xqfun(item.deviceKey,i)" :class="xqfunnum == i?'aa':''">{{item.deviceName}}</li>
        </ul>
        <div ref="new3" style="width: 100%;background-color: var(--Monthly1);height: 400px;margin-top:50px"></div>
      </div>
      <div class="complete2" style="height: 550px;border:none;margin-top:90px">
        <p style="width: 100%;height: 40px;line-height:40px;background: rgba(58, 86, 135, 1);color: #fff; text-indent: 20px;">累计使用时长排行</p>
        <div ref="studentCounts" style="width: 100%;height: 100%;"></div>
      </div>
    </div>
    <div :class="Togglenum==2?'nav':'no'" class="nav" style="position: relative;">
      <p style="color: var(--Monthly3);text-align: left;vertical-align: top;font-size: 18px;padding-top:20px;margin-left:20px">东南大学心理放松舱22</p>
      <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);">截止{{datasgetFullYear}}年{{datasgetMonth}}月,放松舱累计使用 <span style="color: var(--Monthly3);">{{alldata2.totalTimes}}</span>人次。</p>
      <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);"> 所有使用者基线采集过程中的平均心率为<span style="color: var(--Monthly3);">{{alldata2.avgHeartRate}}</span>,放松训练过程中的平均心率为<span style="color: var(--Monthly3);">{{alldata2.trainHeartRate}}</span> </p>
      <p style="margin-top:10px;margin-left:20px;color: var(--Monthly2);">截取放松过程中监测到最低心率的前后 1分钟心率计算平均值，共 <span style="color: var(--Monthly3);">{{alldata2.minHeartRateZb}}%</span> 人低于基线采集过程平均值，身体得到了放松和恢复。</p>
      <ul class="nav-ul2">
        <p style="width: 100%;height: 50px;background: rgba(75, 108, 166, 1);text-align:center;line-height:50px;color: #fff;font-size: 20px;font-weight: 700;">心率</p>
        <li>
          <p style="height: 80px;line-height:100px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata2.avgHeartRate}}</p>
          <p style="height: 80px;line-height:60px;text-align:center;color: var(--Monthly2);font-size: 16px;">基线采集-平均值</p>
        </li>
        <li style="margin-left:-1px">
          <p style="height: 80px;line-height:100px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata2.trainHeartRate}}</p>
          <p style="height: 80px;line-height:60px;text-align:center;color: var(--Monthly2);font-size: 16px;">放松训练-平均值</p>
        </li>
        <li style="margin-left:-1px">
          <p style="height: 80px;line-height:100px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata2.minHeartRate}}</p>
          <p style="height: 80px;line-height:60px;text-align:center;color: var(--Monthly2);font-size: 16px;">降低人次</p>
        </li>
        <li style="margin-left:-1px">
          <p style="height: 80px;line-height:100px;text-align:center;color: var(--Monthly2);font-size: 36px;">{{alldata2.minHeartRateZb}}%</p>
          <p style="height: 80px;line-height:60px;text-align:center;color: var(--Monthly2);font-size: 16px;">占比</p>
        </li>
      </ul>
      <div class="complete2" style="height: 450px;border:none">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px">各部门心率降低</p>
        <ul class="sjli">
          <li>数据来源</li>
          <li style="cursor: pointer;" v-for="(item,i) in GetDictionaryList" :key="i" @click="xqfun2(item.deviceKey,i)" :class="xqfunnum2 == i?'aa':''">{{item.deviceName}}</li>
        </ul>
        <div ref="consultCountDegrees" style="width: 100%;background-color: var(--Monthly1);height: 400px;"></div>
      </div>
      <div class="complete2" style="height: 450px;border:none;margin-top:50px">
        <p style="color:var(--Monthly2);margin-left:20px;margin-top:20px">各部门心率降低人次</p>
        <div ref="consultPersonCountXJ" style="width: 100%;background-color: var(--Monthly1);height: 400px;"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getModelUris } from 'face-api.js/build/commonjs/common';
export default {
  data() {
    return {
      reduceqnty:'',
      totalqnty:'',
      unreduceqnty:'',
      Togglenum:'1',
      qiehuannum:'1',
      region:'',
      zhuti:2,
      month:'',
      alldata:[],
      alldata2:[],
      datas:'',
      datasgetFullYear:'',
      datasgetMonth:'',
      datasgetDate:'',
      GetDictionaryList:[],
      campusKey:'',
      GetDictionaryList2:[],
      campusKey2:'',
      xqfunnum:0,
      xqfunnum2:0,
      fxfunnum:0,
      fxcampusKey:'',
      mubns1:'',
      mubns2:'',
      mubns3:'',
      fxxlfunnum:'',
      scrfunnum:'1',
      fxxlrole:'',
      scrlrole:'本科',
      xlrcfunnum:'',
      xlrccampusKey:'',
      zxztthemeKey:'',
      zxztfunnum:'',
      xlyyfunnum:'1',
      zxztdegree:'本科',
      jsyyfunnum:'1',
      jsrole:'本科部',
      studentCountsdata:[]
    }
  },
  mounted() {
    if(new Date().getMonth().toString()<10){
      this.region = '0' + new Date().getMonth().toString();
    }else{
      this.region = new Date().getMonth().toString();
    }
    this.month = new Date().getFullYear() + '-' + this.region;
    this.$Http_Post("/capsule/device/list").then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.GetDictionaryList = res.Data;
        this.campusKey = res.Data[0].deviceKey;
        this.campusKey2 = res.Data[0].deviceKey;
        this.loading();
        this.loading2();
      } else {
        this.Global.request_failure(res.Message);
      }
    })
    this.datas = new Date();
    this.datasgetFullYear = this.datas.getFullYear();
    this.datasgetMonth = this.datas.getMonth() + 1;
    this.datasgetDate = this.datas.getDate();
  },
  methods: {
    xqfun(val,i){
      this.xqfunnum = i;
      this.campusKey = val;
      this.loading();
    },
    xqfun2(val,i){
      this.xqfunnum2 = i;
      this.campusKey2 = val;
      this.alldata2.trainStatisticByDevices.forEach((item,i) => {
        if(item.deviceKey == this.campusKey2){
          this.reduceqnty = item.reduceqnty
          this.totalqnty = item.totalqnty
          this.unreduceqnty = item.unreduceqnty
        }
      });
      this.consultCountDegrees();
    },
    zxztfun(val,i){
      this.zxztfunnum = i;
      this.zxztthemeKey = val;
      this.loading2();
    },
    jsyyfun(val,i){
      this.jsyyfunnum = i;
      this.jsrole = val;
      this.loading2();
    },
    xlyyfun(val,i){
      this.xlyyfunnum = i;
      this.zxztdegree = val;
      this.loading2();
    },
    yuefenfun(){
      this.month = new Date().getFullYear() + '-' + this.region;
      this.loading();
      this.loading2();
    },
    loading(){
      this.$Http_Post("capsule/deviceuserecord/getmonthdeviceusereport",{month: this.month,deviceKey:this.campusKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.alldata = res.Data;
          this.new3();//11111111111
          this.studentCounts();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    loading2(){
      this.$Http_Post("capsule/deviceuserecord/getmonthtrainreport",{"month": this.month}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.alldata2 = res.Data;
          res.Data.trainStatisticByDevices.forEach((item,i) => {
            if(item.deviceKey == this.campusKey2){
              this.reduceqnty = item.reduceqnty
              this.totalqnty = item.totalqnty
              this.unreduceqnty = item.unreduceqnty
            }
          });
          this.consultCountDegrees();
          this.consultPersonCountXJ();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    consultPersonCountXJ(){
      var reduceqnty = []
      var unreduceqnty = []
      var deviceName = []
      this.alldata2.trainStatisticByDevices.forEach((item,i) => {
        reduceqnty.push(item.reduceqnty)
        unreduceqnty.push(item.unreduceqnty)
        deviceName.push(item.deviceName)
      });
      var myChart = this.$echarts.init(this.$refs.consultPersonCountXJ);
      var option = {
        tooltip: {
          position: function (point, params, dom, rect, size) {
            return [point[0], point[1] - 10];  // 上方 10 像素处
          },
        },
        legend: { y: "5%", textStyle: {color: 'rgba(109, 128, 156, 1)'},itemHeight: 10},
        grid: {left: '3%',right: '4%',bottom: '3%',containLabel: true},
        textStyle: {color: 'rgba(109, 128, 156, 1)'},
        xAxis: {
          type: 'category',
          data: deviceName,
          axisLine:{
            lineStyle:{show:true,color:'rgba(109, 128, 156, 1)',}
          },
        },
        yAxis: {
          type: 'value',
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
          splitLine:{lineStyle:{type:'dashed',color:'rgba(109, 128, 156, 1)'}}
        },
        series: [
          {
            name: '降低',
            type: 'bar',
            data: reduceqnty,
            itemStyle: {color: 'rgba(227, 181, 32, 1)'},
            barWidth:'20px',
            position: 'top'
          },
          {
            name: '未降低',
            type: 'bar',
            data: unreduceqnty,
            itemStyle: {color: 'rgba(60, 177, 240, 1)'},
            barWidth:'20px',
            position: 'top'
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    qiehuanzhut(val){
      // 2白1黑
      this.zhuti = val
      if(val ==2){//黑
        document.documentElement.style.setProperty('--Monthly1', 'rgb(30, 45, 66)');
        document.documentElement.style.setProperty('--Monthly2', 'rgb(255, 255, 255)');
        document.documentElement.style.setProperty('--Monthly3', 'rgb(240, 188, 17)');
      }else{//2白
        document.documentElement.style.setProperty('--Monthly1', 'rgb(255, 255, 255)');
        document.documentElement.style.setProperty('--Monthly2', 'rgb(0, 0, 0)');
        document.documentElement.style.setProperty('--Monthly3', 'rgb(42, 130, 228)');
      }
    },

    qiehuanfun(num){
      this.qiehuannum = num;
    },
    Togglefun(num){
      this.Togglenum = num;
    },
    consultCountDegrees(){
      var yx = []
      var sl = []
      // for(var i = 0;i<this.alldata2.trainStatisticByDevices.length;i++){
      //   yx.push(
      //     {
      //       value: this.alldata2.trainStatisticByDevices[i].consultCount,
      //       name:  this.alldata2.trainStatisticByDevices[i].degree,
      //       itemStyle: { color: this.alldata2.trainStatisticByDevices[i].color}
      //     }
      //   )
      // }
      var myChart = this.$echarts.init(this.$refs.consultCountDegrees);
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {color: 'rgba(109, 128, 156, 1)'},
        },
        title: {
          textStyle: { fontSize: 16, color: '#ffffff' },
          left: '20px',
          top: '10px'
        },
        series: [
          {
            type: 'pie',
            radius: ['50%','70%'],
            center: ['50%','55%'],
            label: {show: true,formatter(param) {return param.name + '(' + param.percent + '%)'}},
            data: [
              {
                value: this.reduceqnty,
                name: '降低',
                itemStyle: { color: 'rgba(60, 177, 240, 1)'}
              },
              {
                value: this.unreduceqnty,
                name: '未降低',
                itemStyle: { color: 'rgba(227, 181, 32, 1)'}
              },
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    new3(){
      var myChart = this.$echarts.init(this.$refs.new3);
      var day = [];
      var testCount = [];
      var testPersonCount = [];
      for(var i = 0; i< this.alldata.deviceUseByDays.length;i++){
        day.push(this.alldata.deviceUseByDays[i].day);
      }
      for(var i = 0; i< this.alldata.deviceUseByDays.length;i++){
        testCount.push(this.alldata.deviceUseByDays[i].testCount);
      }
      for(var i = 0; i< this.alldata.deviceUseByDays.length;i++){
        testPersonCount.push(this.alldata.deviceUseByDays[i].testPersonCount);
      } 
      var option = {
        tooltip: {trigger: 'axis', top:"20px"},
        grid: {left: '3%',right: '4%',bottom: '3%',containLabel: true},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: day,
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        yAxis: {
          type: 'value',
          axisLine:{
            lineStyle:{show:true,color:'rgba(109, 128, 156, 1)',}
          },
          splitLine:{
            lineStyle:{type:'dashed',color:'rgba(109, 128, 156, 1)'}
          }
        },
        series: [
          {
            name: '使用人次',
            type: 'line',
            data: testCount,
            itemStyle: { color: 'rgba(60, 177, 240, 1)'},
            symbolSize: 10,
          },
          {
            name: '使用人数',
            type: 'line',
            data: testPersonCount,
            itemStyle: { color: 'rgba(255, 195, 0, 1)'},
            symbolSize: 10,
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    studentCounts(){
      var hni = [];
      var hni1 = [];
      for(var i = 0;i<this.alldata.deviceUseStatisticList.length;i++){
        hni.push(this.alldata.deviceUseStatisticList[i].testTimes);
        hni1.push(this.alldata.deviceUseStatisticList[i].deviceName);
      }
      hni.reverse();
      hni1.reverse();
      var myChart = this.$echarts.init(this.$refs.studentCounts);
      var option = {
        legend: {y: "5%",textStyle: {color: '#ffffff'},itemHeight: 10,},
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        textStyle: {color: 'rgba(109, 128, 156, 1)'},
        xAxis: {
          type: 'value',
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
          splitLine:{lineStyle:{type:'dashed',color:'rgba(109, 128, 156, 1)'}}
        },
        yAxis: {
          type: 'category',
          data: hni1,
          axisLine:{lineStyle:{show:true,color:'rgba(109, 128, 156, 1)'}},
        },
        series: [
          {
            data: hni,
            type: 'bar',
            itemStyle: {color: 'rgba(7, 193, 96, 1)'},
            lineStyle: {width: 2,type: 'dashed'},
            barWidth:'20px'
          }
        ]
      }
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
}
</script>
<style>

:root {
  --Monthly1: rgba(30, 45, 66, 1);
  --Monthly2: rgb(255 255 255);
  --Monthly3: rgb(240, 188, 17);
  --Monthly4: #f8f8f8;
  --Monthly5: #f8f8f8;
}
.Relax .el-button{padding: 10px 20px;background-color: rgb(75, 108, 166);border: rgb(75, 108, 166);}
.Relax{width: 100%;position: relative;}
.Relax .Monthly_top{height: 80px;width: 100% ;background: linear-gradient(180deg, rgba(54, 85, 138, 1) 0%, rgba(57, 89, 143, 1) 100%);}
.Relax .Select{color: rgba(255, 255, 255, 1) !important;}
.Relax .Select2{color: rgba(255, 255, 255, 1) !important;background: rgba(82, 111, 161, 1) !important;}
.Relax .triangle-down {width: 0;height: 0;border-left: 6px solid transparent;border-right: 6px solid transparent;border-bottom: 12px solid rgb(255, 255, 255);position: absolute;top: 68px;left: 25px;}
.Relax .nav{height: calc(100% - 80px);background: var(--Monthly1);opacity: 1;position: absolute;left: 0px;z-index: 10;min-height: 1420px;width: 100%;}
.Relax .nav1{height: calc(100% - 80px);background: var(--Monthly1);opacity: 1;position: absolute;left: 0px;z-index: 10;min-height: 1460px;top: 80px;z-index: 99;}
.Relax .nav3{height: calc(100% - 80px);background: var(--Monthly1);opacity: 1;width: 100%;position: absolute;top: 80px;left: 0px;z-index: 10;min-height: 1700px;}
.Relax .nav4{height: calc(100% - 80px);background: linear-gradient(180deg, rgba(30, 45, 66, 1) 0%, rgba(38, 44, 54, 1) 100%);opacity: 1;width: 100%;position: absolute;top: 80px;left: 0px;z-index: 10;min-height: 1700px;}
.Relax .el-dropdown { vertical-align: top;}
.Relax .el-dropdown + .el-dropdown { margin-left: 15px;}
.Relax .el-icon-arrow-down {font-size: 12px;}
.Relax .yuefen .el-input__inner{background-color:rgba(75, 108, 166, 1);border:1px solid rgba(75, 108, 166, 1);color: #fff;border-radius:0px}
.Relax .nav-ul {width: calc(100% - 40px);margin-left: 20px;margin-top: 20px;height: 200px;border: 1px solid rgba(109, 128, 156, 1);}
.Relax .nav-ul li{float: left;width: calc(33.33333% - 2px);float: left;height: 100%;}

.Relax .nav-ul2 {width: calc(100% - 40px);margin-left: 20px;margin-top: 20px;height: 200px;border: 1px solid rgba(109, 128, 156, 1);}
.Relax .nav-ul2 li{float: left;width: calc(25% - 2px);float: left;height: 100%;}
.Relax .complete{width: calc(100% - 42px);margin-left: 20px;margin-top: 20px;height: 300px;}
.Relax .complete2{width: calc(100% - 42px);margin-left: 20px;margin-top: 20px;height: 330px;margin-top: 20px;border: 1px solid  rgba(109, 128, 156, 1);}
.Relax .complete2 li{float: left;height: 100%;}
.Relax .complete2 li div{width: 100% !important;}
.Relax .complete2 li canvas {height: 285px !important;width: 100% !important;}
.Relax .complete3{width: calc(100% - 42px);margin-left: 20px;margin-top: 20px;height: 600px;margin-top: 20px;border: 1px solid  rgba(109, 128, 156, 1);}
.Relax .complete4{width: calc(100% - 42px);margin-left: 20px;margin-top: 20px;height: 640px;margin-top: 20px;border: 1px solid  rgba(109, 128, 156, 1);}
.Relax .complete4 li{float: left;height: 100%;}
.Relax .complete4 li canvas {height: 285px !important;}
.Relax .complete3 li{float: left;height: 100%;}
.Relax .complete3 li div{width: 100% !important;}
.Relax .complete3 li canvas {height: 285px !important;width: 100%;}
.Relax .no{opacity: 0 !important;position: absolute;top: 80px;left: 0px;z-index: 0 !important;}
.Relax .biaoge table {width: 100%;border-collapse: collapse;border-spacing: 0;border: 1px solid rgba(109, 128, 156, 1);color: rgba(255, 255, 255, 1);text-align: center;}
.Relax .biaoge table td {border: 1px solid rgba(109, 128, 156, 1);padding: 0;height: 40px;}
.Relax .sjli{margin-top: 20px;color: var(--Monthly2);height: 30px;}
.Relax .sjli li{float: left;padding: 6px 20px;}
.Relax .sjli .aa{background-color: rgba(19, 186, 86, 1);color: #fff;border-radius: 15px;height: 20px;}
.Relax .fffs{background-color: rgba(19, 186, 86, 1);color: #fff;border-radius: 15px;}
</style>
